import { useTranslation } from 'react-i18next';
import { PageContentCard } from '@/components/layout/PageContentCard';
import type { Step } from '../types';

interface DeviceAssignmentTabletProps {
  steps: Step[];
  activeStep: Step['id'];
  onStepChange: (stepId: Step['id']) => void;
  isStepDisabled: (stepId: Step['id']) => boolean;
  renderStepContent: (stepId: Step['id']) => React.ReactNode;
}

export function DeviceAssignmentTablet({
  steps,
  activeStep,
  onStepChange,
  isStepDisabled,
  renderStepContent,
}: DeviceAssignmentTabletProps) {
  return (
    <div className="hidden sm:flex lg:hidden space-y-4 flex-1 min-h-0 flex-col">
      <div className="grid grid-cols-3 gap-2 p-1 bg-surface-darker rounded-md">
        {steps.map((step) => {
          const disabled = isStepDisabled(step.id);
          const isActive = activeStep === step.id;

          return (
            <button
              key={step.id}
              type="button"
              onClick={() => !disabled && onStepChange(step.id)}
              disabled={disabled}
              className={`py-2 px-3 rounded-md text-center transition-colors ${isActive
                ? 'bg-surface shadow-sm text-onsurface'
                : disabled
                  ? 'text-onsurface/40 cursor-not-allowed'
                  : 'text-onsurface/60 hover:text-onsurface'
                }`}
            >
              <HeaderNavContent step={step} />
            </button>
          );
        })}
      </div>

      <PageContentCard className="flex-1 min-h-0 flex flex-col w-full">
        {renderStepContent(activeStep)}
      </PageContentCard>
    </div>
  );
}

function HeaderNavContent({ step }: { step: Step }) {
  const { t } = useTranslation();
  
  return (
    <>
      <div className="text-sm font-medium truncate">{t(step.titleKey)}</div>
      <div className="text-xs opacity-60 mt-0.5 truncate">
        {step.getSubtitle() || ''}
      </div>
    </>
  );
}
